import { throwApiError } from "@/lib/api/errors";
// API client for public forms (landing, pricing, etc.)

export interface DemoRequestIn {
  email: string;
  fullName?: string;
  companyName?: string;
  phone?: string;
  propertyCount?: number;
  message?: string;
  source?: string;
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
  locale?: string;
  promoCode?: string;
}

export interface DemoRequestOut {
  id: string;
  status: string;
  createdAt: string;
}

const API_URL = process.env.NEXT_PUBLIC_API_URL || "http://localhost:8000";

/**
 * Submit a demo request to the backend.
 * Unauthenticated endpoint, no CSRF token required.
 */
export async function submitDemoRequest(
  data: DemoRequestIn
): Promise<DemoRequestOut> {
  // Convert camelCase to snake_case for backend
  const payload = {
    email: data.email,
    full_name: data.fullName || undefined,
    company_name: data.companyName || undefined,
    phone: data.phone || undefined,
    property_count: data.propertyCount || undefined,
    message: data.message || undefined,
    source: data.source || "landing",
    utm_source: data.utmSource || undefined,
    utm_medium: data.utmMedium || undefined,
    utm_campaign: data.utmCampaign || undefined,
    locale: data.locale || "ru",
    promo_code: data.promoCode || undefined,
  };

  // Remove undefined fields
  const cleanPayload = Object.fromEntries(
    Object.entries(payload).filter(([, v]) => v !== undefined)
  );

  const response = await fetch(`${API_URL}/api/v1/public/demo-requests`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(cleanPayload),
  });

  if (!response.ok) {
    await throwApiError(response);
  }

  const result = await response.json();

  // Convert snake_case response to camelCase
  return {
    id: result.id,
    status: result.status,
    createdAt: result.created_at,
  };
}
